module.exports = __webpack_public_path__ + "img/support_zx_01@2x.6a47866e.png";